// extracted by mini-css-extract-plugin
export default {"files":"SkillFileModal_files__BSzXa"};